<template>
  <div class="chart">
    <bar-chart :data="chartData" :index="chartIndex" v-if="chartData.type === 'bar'" />
    <pie-chart :data="chartData" v-else-if="chartData.type === 'pie'" />
    <line-chart :data="chartData" :index="chartIndex" v-else-if="chartData.type === 'line'" />
    <doughnut-chart :data="chartData" v-else-if="chartData.type === 'doughnut'" />
  </div>
</template>

<script>
  import get from 'lodash/get'
  import map from 'lodash/map'
  import BarChart from './BarChart'
  import PieChart from './PieChart'
  import LineChart from './LineChart'
  import DoughnutChart from './DoughnutChart'

  export default {
    name: 'chart',
    props: ['nid', 'chartIndex'],
    components: {
      BarChart,
      PieChart,
      LineChart,
      DoughnutChart,
    },
    computed: {
      node() {
        return this.$store.getters.node(this.nid)
      },
      chartData() {
        return get(this, `charts[${this.chartIndex}]`)
      },
      charts() {
        return map(get(this, 'node.chart_data', []), data => JSON.parse(data))
      },
    },
  }
</script>

<style lang="scss" scoped>
  .chart{
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// Chart.vue?5f6bd847